/**
 * TanStack Query hooks for `tiered-affiliate-onboarding`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	tieredAffiliateOnboardingQueryKeys,
	type CreateTieredAffiliateOnboardingBody,
	type ListTieredAffiliateOnboardingResponse,
	type TieredAffiliateOnboardingRow,
} from "./api";

export function useTieredAffiliateOnboardingList(): UseQueryResult<ListTieredAffiliateOnboardingResponse, Error> {
	return useQuery({
		queryKey: tieredAffiliateOnboardingQueryKeys.list(),
		queryFn: list,
	});
}

export function useTieredAffiliateOnboardingCreate(): UseMutationResult<TieredAffiliateOnboardingRow, Error, CreateTieredAffiliateOnboardingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: tieredAffiliateOnboardingQueryKeys.all });
		},
	});
}

export function useTieredAffiliateOnboardingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: tieredAffiliateOnboardingQueryKeys.all });
		},
	});
}
